/* eslint-disable no-prototype-builtins */
/* eslint-disable max-len */
import React from 'react';

export default function AddressHover({
    type, setaddressPopup, address, setGroupCategoryValue, groupIdx, OrderDetails, UserRole,
}) {
    const handleDisable = () => {
        const arr = ['copec', 'regional_sales_manager'];
        const currentRole = JSON.parse(localStorage.getItem('user')).profile.roles;
        return !arr.includes(UserRole) || currentRole !== OrderDetails.approvals.next_approval;
    };
    return (
        <div className="absolute top-[50px] left-0 bg-[#FFFFFF] rounded-lg address-more sm:px-5 px-3 sm:py-4 py-3 shadow-s7 w-[323px] z-10 adderess-show45 show">
            <div className="flex items-center justify-between">
                <p className="sm:text-xs6 text-sm font-semibopld text-[#808285]">
                    {type}
                    {' '}
                    address
                </p>
                {!handleDisable() && (
                    <button
                        onClick={() => {
                            setGroupCategoryValue(Object.keys(OrderDetails.items)[groupIdx]);
                            setaddressPopup(true);
                        }}
                        disabled={handleDisable()}
                        type="button"
                        className="sm:text-xs6 text-sm font-semibold text-[#808285] change"
                        data-bs-toggle="modal"
                        data-bs-target="#changeaddressModal"
                    >
                        Change
                        {' '}

                    </button>
                )}
            </div>
            <p className="sm:pr-14 pr-9 sm:pt-2 pt-1.5 sm:text-base text-sm font-normal text-[#15090E]">
                <p>
                    {address?.ADDRESS1}
                    ,
                </p>
                <p>
                    {address?.ADDRESS2}
                    ,
                    {address?.ADDRESS3}
                </p>
                <p>
                    {address?.ADDRESS4}
                </p>
                <p>
                    {address?.CITY}
                    -
                    {' '}
                    {`${address?.POSTAL_CODE}`}
                </p>
                <p>

                    {' '}
                    {address?.STATE}
                    ,
                </p>
                {` Location: ${address?.LOCATION}`}

                <p>
                    {` GSTIN :${address?.ATTRIBUTE2}`}
                </p>

            </p>
            <p className="sm:pt-3 pt-2 sm:text-xs6 text-sm font-semibold text-[#808285]">
                Party Site Number
            </p>
            <p className="sm:pr-14 pr-9 sm:pt-1 pt-1 sm:text-base text-sm font-normal text-[#15090E]">
                {address?.PARTY_SITE_NUMBER ?? 'N/A'}
            </p>
        </div>
    );
}
